import { IDataUploadLogDto, SimpleResult } from "../dto";
import { ApiSuffixType } from "../enums";
import { Api, apiUrlBase } from "../helpers";

export class DataUploadApi {
  /** Success means the job reached the ETL queue, not that it has run; the outcome arrives by email. */
  static async execute(
    dataUploadId: number,
  ): Promise<SimpleResult<void> | undefined> {
    const requestUrl = apiUrlBase(
      "dataUpload",
      ApiSuffixType.NoSuffix,
      `${dataUploadId}/execute`,
    );
    const response = await Api.post<SimpleResult<void>>(requestUrl);

    return response?.data;
  }

  /** Already filtered by the backend to redacted Info/Warn messages. Empty `records` = never run. */
  static async fetchLastRunLog(
    dataUploadId: number,
  ): Promise<SimpleResult<IDataUploadLogDto> | undefined> {
    const requestUrl = apiUrlBase(
      "dataUpload",
      ApiSuffixType.NoSuffix,
      `${dataUploadId}/last-run-log`,
    );
    const response = await Api.get<SimpleResult<IDataUploadLogDto>>(requestUrl);

    return response?.data;
  }
}
